import { lazy } from 'react';

const StatsReportRoutes = [
    {
        path: '/reports/stats_reports',
        component: lazy(() => import('../../pages/Reports/StatsReports')),
        exact: true,
        meta: {
            action: 'read',
            resource: 'stats_reports',
        },
    },
    {
        path: '/reports/stats_reports/referral_total_area_of_law',
        component: lazy(() =>
            import('../../pages/Reports/StatsReports/ReferralTotalAreaOfLaw'),
        ),
        meta: {
            action: 'read',
            resource: 'stats_reports',
        },
    },
    {
        path: '/reports/stats_reports/referral_total_other_service',
        component: lazy(() =>
            import(
                '../../pages/Reports/StatsReports/ReferralTotalByOtherService'
            ),
        ),
        meta: {
            action: 'read',
            resource: 'stats_reports',
        },
    },
    {
        path: '/reports/stats_reports/referral_total_by_area_of_law_and_law_firm_city',
        component: lazy(() =>
            import(
                '../../pages/Reports/StatsReports/ReferralTotalByAreaLawAndCity'
            ),
        ),
        meta: {
            action: 'read',
            resource: 'stats_reports',
        },
    },
    {
        path: '/reports/stats_reports/member_registration_count',
        component: lazy(() =>
            import('../../pages/Reports/StatsReports/MemberRegistrationCount'),
        ),
        meta: {
            action: 'read',
            resource: 'stats_reports',
        },
    },

    /* APB */
    {
        path: '/reports/stats_reports/referral_total_area_of_law_apb',
        component: lazy(() =>
            import('../../pages/Reports/StatsReports/ReferralTotalAreaOfLaw'),
        ),
        meta: {
            action: 'read',
            resource: 'apb_reports',
        },
    },
    {
        path: '/reports/stats_reports/referral_total_other_service_apb',
        component: lazy(() =>
            import(
                '../../pages/Reports/StatsReports/ReferralTotalByOtherService'
            ),
        ),
        meta: {
            action: 'read',
            resource: 'apb_reports',
        },
    },
    {
        path: '/reports/stats_reports/referral_total_by_area_of_law_and_law_firm_city_apb',
        component: lazy(() =>
            import(
                '../../pages/Reports/StatsReports/ReferralTotalByAreaLawAndCity'
            ),
        ),
        meta: {
            action: 'read',
            resource: 'apb_reports',
        },
    },
    {
        path: '/reports/stats_reports/member_registration_count_apb',
        component: lazy(() =>
            import('../../pages/Reports/StatsReports/MemberRegistrationCount'),
        ),
        meta: {
            action: 'read',
            resource: 'apb_reports',
        },
    },
];

export default StatsReportRoutes;
